import { H2Medium as H2MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the H2Medium typography style.
 */
export default function H2Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(H2MediumStyle, sx)} />;
}
